import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation_en from './assets/locales/en/translation.json';
import translation_es from './assets/locales/es/translation.json';
import translation_ca from './assets/locales/ca/translation.json';

//import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

//const languageDetector = new LanguageDetector();
//languageDetector.addDetector({
//  name: 'i18nLangDetector',
//  convertDetectedLanguage: (lng) => lng.replace('-', '_')
//});

i18n
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
	
	resources: {
		en: {
			translation: translation_en
		},
		es: {
			translation: translation_es
		},
		ca: {
			translation: translation_ca
		}
	},
	useSuspense: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
	detection:{
		//convertDetectedLanguage: (lng) => lng.replace('-', '_')
	}
  });


export default i18n;